import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  name?: string;
  email?: string;
};

const [useUpdateUserProfile, updateUserProfile] = createAsyncAction(
  "user/updateProfile",
  async ({ name, email }: Args) => {
    const res = await API.call<{ user: number }>({
      endpoint: `me/`,
      method: "PUT",
      data: {
        name,
        email,
      },
    });
    return { ...res, result: res.result.user };
  }
);

export default useUpdateUserProfile;
export { updateUserProfile };
